"use client";

import { Images } from "lucide-react";
import { Button } from "@tripcart/traveler-ui/components/button";

import { useMediaGallery } from "@/components/experience-media-gallery";
import { useTranslator } from "@/lib/translation-context";

import styles from "./view-all-button.module.css";

/**
 * Compact "View all media" CTA pinned to the bottom-right of the bento grid
 * (reference layout). Rendered only by the 5+ branch of the hero, where there
 * are more photos than the grid shows. Tiny client island — whether there IS
 * a full pool to view is the only thing that needs the live array.
 */
export function ViewAllMediaButton() {
  const { media, openByIndex, prewarm } = useMediaGallery();
  const t = useTranslator();
  if (media.length === 0) return null;
  return (
    <Button
      variant="secondary"
      onPointerEnter={prewarm}
      onFocus={prewarm}
      onClick={() => openByIndex(0)}
      className={styles.button}
    >
      <Images strokeWidth={1.75} />
      {t("View All Media")}
    </Button>
  );
}
